var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeachersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    height: 150,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "-6.34%",
    x2: "102%",
    y1: "-41.829%",
    y2: "101%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F4635B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C86DD7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: "168.2%",
    height: "168.2%",
    x: "-34.1%",
    y: "-29.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.831372549 0 0 0 0 0.415686275 0 0 0 0 0.709803922 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 23.477,
    cy: 23.477,
    r: 23.477
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(20 20)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "#000",
    filter: "url(#b)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(5.796 12.895)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A2929",
    d: "M17.7931398,12.1375418 L17.7267978,12.1375418 L9.14133544,12.2858357 L9.14133544,17.2575859 C9.13994045,17.4664637 9.20560002,17.670282 9.3286766,17.8390544 C10.1091711,18.9512591 13.410663,21.6205504 17.7346028,21.6634776 L17.8009448,21.6634776 C22.128787,21.6205504 25.4107665,18.9317467 26.206871,17.8390544 C26.3283122,17.6696799 26.3925647,17.4659858 26.3903457,17.2575859 L26.3903457,12.2858357 L17.7931398,12.1375418 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M9.13355297,12.4458371 L18.198997,18.6078415 C18.3999959,18.7441611 18.6578187,18.7649055 18.8780273,18.6624761 L26.3902872,15.1268358 L26.3902872,11.3492423 L9.13355297,12.4458371 Z",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M35.4830485,8.20384931 L18.1560698,16.0087947 C17.9247058,16.1100294 17.6615739,16.1100294 17.4302099,16.0087947 L0.103231185,8.20384931 C0.0403831896,8.17541866 3.19744231e-14,8.11282743 3.19744231e-14,8.04384793 C3.19744231e-14,7.97486842 0.0403831896,7.9122772 0.103231185,7.88384655 L17.4302099,0.0789011839 C17.6607278,-0.0263003946 17.9255519,-0.0263003946 18.1560698,0.0789011839 L35.4830485,7.88384655 C35.5458965,7.9122772 35.5862797,7.97486842 35.5862797,8.04384793 C35.5862797,8.11282743 35.5458965,8.17541866 35.4830485,8.20384931 L35.4830485,8.20384931 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE5160",
    d: "M9.23501726,20.4029789 L8.84476999,20.1688305 L8.45449918,20.4029789 L8.45449918,12.1375418 C8.45275678,11.9761959 8.55047028,11.8304012 8.7003785,11.7707093 L17.7736275,7.76677237 L18.5775369,8.28189876 L9.23501726,12.4029099 L9.23501726,20.4029789 Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeachersIcon);
export default __webpack_public_path__ + "static/media/Teachers-icon.e2ea211b27bdef8847d9c67d660eef64.svg";
export { ForwardRef as ReactComponent };